export enum LabelSizes {
  SMALL = '10px',
  NORMAL = '18px',
  LARGE = '24px',
}
